module.exports = __webpack_public_path__ + "static/media/positive-image3.e17b41b4.png";